import { styled as t, Box as r, Typography as s } from "@mui/material";
import w from "../../../assets/images/image-chicken.png.js";
import k from "./AdeptusCodeInput.js";
import b from "../../share/apeiron/ApeironLinkButton.js";
import C from "../../share/next/Image.js";
import P from "../../share/popup/InfoPopup.js";
import y from "../../../config/index.js";
import { AdeptusInputMode as A } from "../../../constants/adeptus.js";
import { INFO_POPUP_TYPE as I } from "../../../constants/popup.js";
import { useAccountContext as R } from "../../../contexts/account/AccountContext.js";
import { useAdeptusContext as _ } from "../../../contexts/adeptus/AdeptusContext.js";
import B from "path";
import * as N from "ramda";
import { useCallback as c } from "react";
import { useTranslation as v } from "react-i18next";
import { jsxs as i, jsx as n } from "react/jsx-runtime";
const z = t(P)`
  max-width: 600px;
  width: 90%;
`, E = t(r)`
  align-items: center;
  display: flex;
  flex-direction: column;
  left: 50%;
  position: absolute;
  top: -160px;
  transform: translate(-50%, 0px);
`, O = t(C)`
  ${(e) => e.theme.breakpoints.up("res1024")} {
    width: 250px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    width: 200px;
  }
  aspect-ratio: 1;
`, T = t(r)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: flex-start;
  padding: 10px 40px 60px 40px;
  width: 100%;
`, j = t(s)`
  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 50px;
    line-height: 50px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 36px;
    line-height: 36px;
  }
  -webkit-text-stroke: 2px #4f5668;
  color: #f3f8e1;
  font-family: Impact;
  margin-bottom: 40px;
`, L = t(s)`
  color: #ccc;
  font-family: Arial;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
`, S = t(k)`
  max-width: 300px;
`, $ = t(r)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: -8px;
`, F = t(s)`
  font-size: 12px;
  font-weight: 300;
  line-height: 12px;
`, m = t(b)`
  background-color: #005bd7;
  border-radius: 4px;
  font-size: 16px;
  padding: 16px 0px;
`, et = (e) => {
  const {
    showRemark: u = !0
  } = e, {
    t: p
  } = v(), {
    successInviter: l,
    setSuccessInviter: a
  } = _(), {
    account: o,
    bindWalletAddress: f,
    setShowBindWalletPopup: x
  } = R(), d = c(() => {
    a(null);
  }, [a]), h = c(async () => {
    x(!0), d();
  }, [f]), g = B.join(y.URL.MARKETPLACE, "user/setting");
  return /* @__PURE__ */ i(z, {
    type: I.PURPLE,
    open: !N.isNil(l),
    onClose: d,
    keepMounted: !1,
    children: [/* @__PURE__ */ n(E, {
      children: /* @__PURE__ */ n(O, {
        src: w
      })
    }), /* @__PURE__ */ i(T, {
      children: [/* @__PURE__ */ n(j, {
        children: p("adeptus.popup.congratulation")
      }), /* @__PURE__ */ n(L, {
        children: p("adeptus.popup.believe_success")
      }), /* @__PURE__ */ n(S, {
        mode: A.SuccessPopup,
        presetInviter: l,
        showFoot: !1,
        showHead: !1
      }), u && /* @__PURE__ */ i($, {
        children: [/* @__PURE__ */ n(F, {
          children: p("adeptus.popup.booty_remark")
        }), (o == null ? void 0 : o.id) && !o.email && /* @__PURE__ */ n(m, {
          url: g,
          children: p("adeptus.popup.bind_email")
        }), (o == null ? void 0 : o.id) && !o.walletAddress && /* @__PURE__ */ n(m, {
          onClick: h,
          children: p("adeptus.popup.bind_wallet")
        })]
      })]
    })]
  });
};
export {
  et as default
};
//# sourceMappingURL=AdeptusSuccessPopup.js.map
